const responsivePoints = [600, 768, 960, 1264];

export const defaultSlickSettings = (
  responsiveSlides: number[],
  respPoints: number[] = responsivePoints
): {
  slidesToShow: number;
  responsive: {
    breakpoint: number;
    settings: { slidesToShow: number };
  }[];
} => ({
  slidesToShow: responsiveSlides[0],
  responsive: responsiveSlides.slice(1).map((rv, idx) => ({
    breakpoint: respPoints.slice().reverse()[idx],
    settings: {
      slidesToShow: rv,
    },
  })),
});

export const getNumberOfSlides = (
  width: number,
  responsiveSlides: number[],
  respPoints: number[] = responsivePoints
): number => {
  const truthKeyPair = responsiveSlides.slice(1).reduce(
    (prev, curr, idx) => ({
      ...prev,
      [respPoints[idx]]: curr,
    }),
    {} as Record<number, number>
  );
  for (let i = respPoints.length - 1; i >= 0; i--) {
    if (width >= respPoints[i] && truthKeyPair[respPoints[i]]) {
      return truthKeyPair[respPoints[i]];
    }
  }
  return responsiveSlides[0];
};
